import baseURL from '../modules/api/url'
import { strings } from '../context/LanguageContext/strings'

export const Orders = {
    getOrderHeadCells: () => [
        {
            id: 'order_id',
            label: strings.OPS_TOOLS_ORDERS_ORDER_ID_LABEL,
            draggable: false,
            width: '15%',
            align: 'center',
        },
        {
            id: 'customer_name',
            label: strings.OPS_TOOLS_ORDERS_CUSTOMER_NAME_LABEL,
            draggable: false,
            width: '15%',
        },
        {
            id: 'loyalty_id',
            label: strings.OPS_TOOLS_ORDERS_LOYALTY_ID,
            draggable: false,
            width: '18%',
        },
        {
            id: 'created',
            label: strings.OPS_TOOLS_ORDERS_CREATED,
            draggable: false,
            width: '18%',
        },
        {
            id: 'store_id',
            label: strings.OPS_TOOLS_ORDERS_STORE_ID,
            draggable: false,
            width: '15%',
        },
        {
            id: 'order_status',
            label: strings.OPS_TOOLS_ORDERS_STATUS,
            draggable: false,
            width: '15%',
        },
        {
            id: 'transaction_status',
            label: strings.OPS_TOOLS_ORDERS_TRANSACTION_STATUS,
            draggable: false,
            width: '15%',
        },
        {
            id: 'sub_total',
            label: strings.OPS_TOOLS_ORDERS_SUB_TOTAL,
            draggable: false,
            width: '15%',
        },
    ],
    getOrdersFilters: () => [
        {
            type: 'list',
            key: 'orderStatus',
            display_name: strings.ORDER_STATUS,
            display_value: [],
            post_value: [],
            displayPillUtil: list => {
                const orderStatuses = Orders.getOrderStatus()
                return list.map(item => orderStatuses.find(s => s.value === item).display)
            },
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
        {
            type: 'range',
            key: 'date_range',
            display_name: strings.SECTION_MANAGE_PROMOTIONS_TABLE_CONTENT_DATE,
            start_value: '',
            end_value: '',
            display_value: '',
            defaultDisplayValue: '',
        },
        {
            type: 'list',
            key: 'store_id',
            display_name: strings.SECTION_MANAGE_STORES_IMPORTS_TABLE_STORE_ID,
            display_value: [],
            post_value: [],
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
        {
            type: 'list',
            key: 'order_id',
            display_name: strings.OPS_TOOLS_ORDERS_ORDER_ID_LABEL,
            display_value: [],
            post_value: [],
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
        {
            type: 'list',
            key: 'loyalty_id',
            display_name: strings.OPS_TOOLS_ORDERS_LOYALTY_ID,
            display_value: [],
            post_value: [],
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
        {
            type: 'list',
            key: 'customer_name',
            display_name: strings.OPS_TOOLS_ORDERS_CUSTOMER_NAME_LABEL,
            display_value: [],
            post_value: [],
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
        {
            type: 'list',
            key: 'transaction_status',
            display_name: strings.OPS_TOOLS_ORDERS_TRANSACTION_STATUS,
            display_value: [],
            post_value: [],
            displayPillUtil: list => {
                const transactionStatuses = Orders.getTransactionStatus()
                return list.map(item => transactionStatuses.find(s => s.value === item).display)
            },
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
    ],

    orderDetailsUrl: `${baseURL.SEVEN_NOW_CORE_API_URL}/order/order/adminportal/`,
    orderExportsUrl: `${baseURL.SEVEN_NOW_CORE_API_URL}/order/order/export/`,

    orderTypes: {
        DELIVERY: 'delivery',
        PICKUP: 'pickup',
        SELF_CHECKOUT: 'selfcheckout',
    },

    getDeliveryOrderSteps: () => [
        {
            ix: 0,
            label: strings.SECTION_ORDER_DETAIL_PAGE_STEPPER_SUBMITTED,
            statuses: ['submitted'],
        },
        {
            ix: 1,
            label: strings.SECTION_ORDER_DETAIL_PAGE_STEPPER_IN_PROGRESS,
            statuses: ['in_progress'],
        },
        { ix: 2, label: strings.SECTION_ORDER_DETAIL_PAGE_STEPPER_READY, statuses: ['ready'] },
        {
            ix: 3,
            label: strings.SECTION_ORDER_DETAIL_PAGE_STEPPER_OUT_FOR_DELIVERY,
            statuses: ['out_for_delivery'],
        },
        {
            ix: 4,
            label: strings.SECTION_ORDER_DETAIL_PAGE_STEPPER_DELIVERED,
            statuses: ['delivered'],
        },
        {
            ix: 5,
            label: strings.CANCELED,
            statuses: ['canceled'],
        },
    ],

    getPickupOrderSteps: () => [
        {
            ix: 0,
            label: strings.SECTION_ORDER_DETAIL_PAGE_STEPPER_SUBMITTED,
            statuses: ['submitted'],
        },
        {
            ix: 1,
            label: strings.SECTION_ORDER_DETAIL_PAGE_STEPPER_IN_PROGRESS,
            statuses: ['in_progress'],
        },
        {
            ix: 2,
            label: strings.SECTION_ORDER_DETAIL_PAGE_STEPPER_READY_FOR_PICKUP,
            statuses: ['ready'],
        },
        {
            ix: 3,
            label: strings.SECTION_ORDER_DETAIL_PAGE_STEPPER_COMPLETE,
            statuses: ['picked_up'],
        },
        {
            ix: 4,
            label: strings.CANCELED,
            statuses: ['canceled'],
        },
    ],

    getPreOrderPickupOrderSteps: () => [
        {
            ix: 0,
            label: strings.preOrder,
            statuses: ['preorder'],
        },
        {
            ix: 1,
            label: strings.SECTION_ORDER_DETAIL_PAGE_STEPPER_SUBMITTED,
            statuses: ['submitted'],
        },
        {
            ix: 2,
            label: strings.SECTION_ORDER_DETAIL_PAGE_STEPPER_IN_PROGRESS,
            statuses: ['in_progress'],
        },
        {
            ix: 3,
            label: strings.SECTION_ORDER_DETAIL_PAGE_STEPPER_READY_FOR_PICKUP,
            statuses: ['ready'],
        },
        {
            ix: 4,
            label: strings.SECTION_ORDER_DETAIL_PAGE_STEPPER_COMPLETE,
            statuses: ['picked_up'],
        },
        {
            ix: 5,
            label: strings.CANCELED,
            statuses: ['canceled'],
        },
    ],

    orderTimeFormatTemplate: 'h:mm A',

    fop: {
        paypal: 'paypal',
        venmo: 'venmo',
        applePay: 'Apple Pay',
        googlePay: 'Google Pay',
    },

    getOrderType: () => [
        {
            value: 'all',
            display: strings.ALL,
        },
        {
            value: 'selfcheckout',
            display: strings.SECTION_ORDER_DETAIL_PAGE_ORDER_TYPE_SELF_CHECKOUT,
        },
        {
            value: 'pickup',
            display: strings.SECTION_ORDER_DETAIL_PAGE_ORDER_TYPE_PICKUP,
        },
        {
            value: 'delivery',
            display: strings.SECTION_ORDER_DETAIL_PAGE_ORDER_TYPE_DELIVERY,
        },
    ],

    getOrderStatus: () => [
        {
            value: 'all',
            display: strings.ALL,
        },
        {
            value: 'selfcheckedout',
            display: strings.SELF_CHECKED_OUT,
        },
        {
            value: 'picked_up',
            display: strings.PICKEDUP,
        },
        {
            value: 'delivered',
            display: strings.DELIVERED,
        },
        {
            value: 'canceled',
            display: strings.CANCELLED,
        },
        {
            value: 'returned',
            display: strings.RETURNED,
        },
    ],

    getTransactionStatus: () => [
        {
            value: 'all',
            display: strings.ALL,
        },
        {
            value: 'success',
            display: strings.SUCCESS,
        },
        {
            value: 'CREATED',
            display: strings.CREATED,
        },
    ],
}
